<template>
  <div :class="{'text-center': $vuetify.breakpoint.xs}">
    <v-btn
      v-if="!showLoadingMessage"
      color="primary"
    >
      <JsonCSV
        :data="formatCSV(filteredItems)"
        name="stakeholders.csv"
      >
        Export Stakeholders
      </JsonCSV>
    </v-btn>
  </div>
</template>
<script>
import JsonCSV from 'vue-json-csv'

export default {
  name: "ExportStakeholders",
  components: {
    JsonCSV
  },
  props: { filteredItems: {type: Array, default: () => []}, showLoadingMessage: {type: Boolean, default: () => true}},
  methods: {
    formatCSV(filteredItems) {
      return filteredItems.map(
        ({
          id,
          /* eslint-disable */ // because eslint isn't ignoring this object due to being called in the map
          get_full_name,
          get_full_name_with_postal_code,
          /* eslint-enable */
          url,
          pk,
          ...others
        }) => others
      );
    },
  }
}
</script>